import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function DocumentDateEditor({ date, path, label, disabled, lockToken, onSaved }) {
  const [value, setValue] = useState((date || "").slice(0, 10));
  const [busy, setBusy] = useState(false);
  useEffect(() => { setValue((date || "").slice(0, 10)); }, [date]);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(path, { date: value }, { headers: lockToken ? { "X-Plan-Lock-Token": lockToken } : {} });
      await onSaved?.();
      toast.success("Belge tarihi kaydedildi. Güncel tarih için PDF’yi yeniden indirin.");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Tarih kaydedilemedi"); }
    finally { setBusy(false); }
  };
  return <section className="mx-4 mb-4 bg-white border border-slate-200 p-3 flex flex-wrap gap-3 items-end">
    <label className="text-xs font-semibold">{label}<input aria-label={label} data-testid="document-date" type="date" value={value} disabled={disabled || busy} onChange={e => setValue(e.target.value)} className="block border border-slate-300 p-2 mt-1" /></label>
    <button data-testid="save-document-date" onClick={save} disabled={disabled || busy || !value || value === (date || "").slice(0, 10)} className="bg-blue-600 text-white px-3 py-2 text-sm disabled:opacity-40">Tarihi Kaydet</button>
    <span className="text-xs text-slate-500 pb-2">Geçmiş bir tarih seçebilirsiniz.</span>
  </section>;
}
